// extracted by mini-css-extract-plugin
export default {"loaderContainer":"allRegions_loaderContainer__JxCrP"};